import { push } from 'connected-react-router';
import * as ActionTypes from '../constants/ActionTypes';
import API from '../helpers/api';

export function getCaterers() {
	return async (dispatch) => {
		dispatch({
			type: ActionTypes.GET_RATING_CATERERS_REQUEST,
			payload: { loading: true }
		});

		const response = await API.rating.getCaterers();

		if (response.meta.code !== 200) {
			return dispatch({
				type: ActionTypes.GET_RATING_CATERERS_ERROR,
				payload: { meta: response.meta, loading: false }
			});
		}

		dispatch({
			type: ActionTypes.GET_RATING_CATERERS_SUCCESS,
			payload: { loading: false, caterers: response.data.caterers }
		});
	};
}

export function onSubmit(fields) {
	return async (dispatch) => {
		dispatch({
			type: ActionTypes.SUBMIT_RATING_PAGE_REQUEST,
			payload: { loadingSubmit: true }
		});

		const body = {
			rating_response: {
				caterer_id: fields.caterer_id,
				rating_1: fields.rating_1,
				rating_2: fields.rating_2,
				rating_3: fields.rating_3,
				other_comments: fields.other_comments || undefined
			}
		};

		const response = await API.rating.createRatingResponse(body);

		if (response.meta.code !== 200) {
			return dispatch({
				type: ActionTypes.SUBMIT_RATING_PAGE_ERROR,
				payload: { meta: response.meta, loadingSubmit: false }
			});
		}

		dispatch(push(`/rating-success?caterer=${encodeURIComponent(fields.caterer_name)}`));
	};
}

export function resetMeta() {
	return async dispatch => {
		dispatch({ type: ActionTypes.RESET_RATING_PAGE_META });
	};
}

export function resetPage() {
	return async dispatch => {
		dispatch({ type: ActionTypes.RESET_RATING_PAGE });
	};
}
